// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-2000ft-rule.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-2000ft-rule/aerodrome-2000ft-rule.js';

mount([g0]);
